import { render, staticRenderFns } from "./BlogSidebar.vue?vue&type=template&id=60f0a986&"
import script from "./BlogSidebar.vue?vue&type=script&lang=js&"
export * from "./BlogSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports